import React, { CSSProperties } from 'react';
import { connect } from 'react-redux';
import PurchaseModal from 'components/Fate/components/PurchaseModal';
import { IAppState } from "types/app";

interface OwnProps {
  className?: string,
  disableTouchEvents?: boolean,
  isOpen: boolean,
  onRequestClose: () => void,
  overlayClassName?: string,
  style?: { overlay?: CSSProperties, content?: CSSProperties },
}

interface StateProps {
  fateCards?: any[],
}

export type Props = OwnProps & StateProps;

export const ActionRefreshModal: React.FC<Props> = ({
  className,
  disableTouchEvents,
  fateCards,
  isOpen,
  onRequestClose,
  overlayClassName,
  style,
}) => {
  if ((fateCards?.length || 0) <= 0) {
    return null;
  }

  return (
    <PurchaseModal
      className={className}
      data={fateCards!.find(({ action }: { action: string }) => action === 'RefillActions')}
      disableTouchEvents={disableTouchEvents}
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      overlayClassName={overlayClassName}
      style={style}
    />
  );
};

const mapStateToProps = ({ fate: { data: { fateCards } } }: IAppState) => ({ fateCards });

export default connect(mapStateToProps)(ActionRefreshModal);
